<!-- 2022-01-15 以前的 全站卡套餐协议-->
<template>
  <div class="goods-vip-forever-protocol">
    <app-header :title="title" />
    <div class="protocol-content" :class="{ scroll: isBuy }">
      <span class="title">《友邻少年全站卡套餐协议》</span>
      <h2>【特别提示条款】</h2>
      <ul>
        <li>
          《友邻少年全站卡套餐协议》（以下简称“本协议”）为《用户许可协议》的补充协议，由您与北京每日友邻文化科技有限公司（以下称“本公司”）共同签订。
        </li>
        <li>
          【审慎阅读】您在购买友邻少年全站卡套餐流程中点击同意本协议之前，应当认真阅读本协议，并审慎选择接受或不接受本协议。
          <span class="underline">
            请您务必审慎阅读、充分理解各条款内容，并重点阅读与您约定免除或者限制责任的条款及其他以粗体下划线标识的重要条款。
          </span>
          本协议有助于您了解本公司为您提供的友邻少年全站卡套餐服务内容及您使用服务的权利和义务。如您对本协议条款有任何疑问，您可通过客服电话
          <span class="weight">010-62565909</span>
          进行咨询。
        </li>
        <li>
          【签约动作】当您按照阅读并点击同意本协议且完成全部购买程序后，即表示您已充分阅读、理解并接受本协议的全部内容。本协议自您接受之时起生效并成为您与北京每日友邻文化科技有限公司之间直接有约束力的法律文件。
        </li>
      </ul>
      <h2>第一条 服务内容</h2>
      <ul>
        <li>
          1.1
          <span class="underline">
            经开启全站卡套餐服务，若无特殊情况，您可以自购买之日起一年内免费收听全站卡权益内的所有专辑。一年到期后，前述所有课程内容不为您保留，无法继续收听。
          </span>
        </li>
        <li>
          1.2
          <span class="underline">
            当您同意购买本服务时，即代表您知晓并同意本公司不承诺和保证自您购买之日起一年服务期内友邻少年APP内更新的音频数量等内容。
          </span>
        </li>
        <li>
          1.3
          <span class="underline">
            当您购买本服务，即代表您理解并同意，由于版权到期或课程调整等其他原因，本公司可能会不定期对友邻少年APP内部分课进行调整、增减，相关课程学习使用方式的最终解释权归本公司所有。
          </span>
        </li>
      </ul>
      <h2>第二条 收费标准</h2>
      <ul>
        <li>2.1 全站卡套餐服务是收费服务，当您根据提示支付完毕相关费用后，本项服务即时生效。</li>
        <li>
          2.2
          本公司可能会根据本服务的整体规划，对本服务相关权益细则、收费标准、方式等进行修改和变更，并可能根据实际情况，对不同阶段充值的会员给予不同的增值服务或资费政策，
          <span class="underline">具体收费标准以友邻少年在相关服务页面公示的信息为准。</span>
          您同意继续操作的行为（包括但不限于点击同意、支付行为等），即视为您知悉并同意该收费标准。
        </li>
      </ul>
      <h2>第三条 退款服务</h2>
      <ul>
        <li>
          3.1
          <span class="underline">
            全站卡套餐为“7天内可退款”商品，您应按照《用户协议》关于“退款服务”的约定进行退款申请，但“7天内”退款须同时满足如下条件：
            <br />
            • 申请退款时间在付款时间的7个自然日内；
            <br />
            • 申请退款的用户听课时长不足180分钟；
            <br />
            • 申请退款的用户不得下载超过
            <span class="weight">【3】</span>
            个音视频文件。
          </span>
        </li>
        <li>
          3.2
          <span class="underline">
            本条款约定的退款金额的计算基数系您在订阅全站卡套餐服务时所实际支付的金额，不包含优惠券、奖励金等（简称“实际支付金额”）。报名时如有赠品，若赠品为实体物品且全新未拆封，申请退款时您可将赠品自费邮寄回本公司，本公司验收赠品后将按照实际支付金额将退款返回您支付时所选择的支付渠道；实体物品如已拆封，本公司将按照实际支付金额扣除实体物品同等金额的费用后将退款返回您支付时所选择的支付渠道；赠品若为线上课程，退款后将被关闭无法继续学习。
          </span>
        </li>
      </ul>

      <h2>第四条 服务中断或终止</h2>
      <ul>
        <li class="weight">
          如发生下列任何一种情况，本公司有权随时中断或终止向您提供本条款项下的课程服务而无需通知您：
          <br />
          （1）您提供的个人资料不真实；
          <br />
          （2）您违反本协议约定；
          <br />
          （3）您违反友邻少年《用户协议》或友邻少年APP上的任何其他条款；
          <br />
          （4）您通过其他未经友邻少年认可的渠道非法购买本全站卡套餐服务；
          <br />
          （5）您违反国家法律、法规的其他规定。
          <br />
          <span class="underline">
            在发生上述情况下，友邻少年有权暂时或永久封禁您的账号。在封禁期间，全站卡套餐服务时长不停止计算，同时您无法申请退款。
          </span>
        </li>
      </ul>

      <h2>第五条 其他</h2>
      <ul>
        <li>本协议为友邻少年《用户许可协议》的补充协议，本协议未约定事宜，均适用《用户许可协议》相关约定。</li>
      </ul>
    </div>
    <!-- 选择协议购买 -->
    <div class="select-protocol-buy" v-if="isBuy">
      <div class="select-protocol">
        <span class="card-icon">
          <img
            class="icon-32"
            v-if="form.protocol === 1"
            @click="toggleValue('protocol')"
            src="../../../../images/goods-vip-forever/icon-checkbox-select.png"
            alt=""
          />
          <img
            class="icon-32"
            v-if="form.protocol === 0"
            @click="toggleValue('protocol')"
            src="../../../../images/goods-vip-forever/icon-checkbox.png"
            alt=""
          />
          <span class="link" @click="detailView('goods-vip-forever-protocol2022')">同意《无限卡购买协议》</span>
        </span>
        <button class="btn btn-active" @click="buyGoods">立即购买</button>
      </div>
    </div>
  </div>
</template>

<script>
import Body from '@/mixins/body'
import { Toast } from 'mint-ui'
const componentName = 'goods-vip-all-protocol'
export default {
  name: componentName,
  componentName,
  mixins: [Body],
  data() {
    return {
      title: '友邻少年全站卡套餐协议',
      form: {
        protocol: 0
      }
    }
  },
  computed: {
    isBuy() {
      return this.$route.query.isBuy
    }
  },
  methods: {
    toggleValue(name) {
      const value = this.form[name]
      this.form[name] = value ? 0 : 1
    },
    buyGoods() {
      if (this.form.protocol === 0) {
        Toast({ message: '请阅读并勾选《无限卡购买协议》，否则无法进行购买', position: 'middle' })
      } else {
        const { goodsId } = this.$route.query
        // 跳转订单支付
        if (goodsId) {
          this.$router.push({
            path: `/confirm-order/${goodsId}`,
            query: { paytype: 'vip' }
          })
        } else {
          Toast({ message: '请联系班主任获取《无限卡购买》入口', position: 'middle' })
        }
      }
    }
  }
}
</script>

<style lang="scss">
.body-goods-vip-forever-protocol {
  #app {
    display: flex;
    .goods-vip-forever-protocol {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
<style lang="scss" scoped>
.protocol-content {
  // height: 70%;
  overflow: scroll;
}
// 选择协议
.select-protocol-buy {
  margin: 0.3rem 0.3rem;
  border-top: 1px solid #eeeeee;
  padding-top: 0.3rem;
  .select-protocol {
    .card-icon {
      margin-right: 0.15rem;
    }
    .link {
      text-decoration: underline;
      margin-left: 0.15rem;
    }
    // 图标
    .icon-32 {
      vertical-align: sub;
      width: 0.32rem;
    }
    // 购买按钮
    .btn {
      padding: 0.24rem 0.4rem;
      background-color: #00b25a;
      border-radius: 0.12rem;
      color: #fff;
      width: 100%;
      margin-top: 0.3rem;
    }
  }
}
ul {
  margin: 0.2rem 0.2rem;
}
ul li {
  list-style: none;
  line-height: 0.5rem;
  font-size: 0.3rem;
  margin: 0.3rem 0.2rem;
  &.weight,
  .weight {
    font-weight: bold;
  }
  .underline {
    text-decoration: underline;
    font-weight: 600;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #44546a;
  }
  table {
    width: 100%;
    min-height: 25px;
    line-height: 25px;
    text-align: center;
    border-collapse: collapse;
    padding: 2px;
  }
}
.indent {
  margin-left: 20px;
}
ul.indent {
  margin-left: 25px;
  margin-top: 0;
}
.title {
  text-align: center;
  margin-top: 20px;
  display: block;
}
h2 {
  margin: 0.48rem 0.48rem 0.3rem 0.4rem;
  font-size: 0.32rem;
}
.company {
  display: flex;
  flex-direction: column;
  text-align: right;
  margin-top: 10px;
}
.link {
  text-decoration: none;
  color: #44546a;
}
</style>
